export const exchangeConstants = {
    ADD_REQUEST: 'EXCHANGE_ADD_REQUEST',
    ADD_SUCCESS: 'EXCHANGE_ADD_SUCCESS',
    ADD_FAILURE: 'EXCHANGE_ADD_FAILURE',

    GETALL_REQUEST: 'EXCHANGE_GETALL_REQUEST',
    GETALL_SUCCESS: 'EXCHANGE_GETALL_SUCCESS',
    GETALL_FAILURE: 'EXCHANGE_GETALL_FAILURE',

    DELETE_REQUEST: 'EXCHANGE_DELETE_REQUEST',
    DELETE_SUCCESS: 'EXCHANGE_DELETE_SUCCESS',
    DELETE_FAILURE: 'EXCHANGE_DELETE_FAILURE',

    GETALL_PAGE_REQUEST: 'EXCHANGE_GETALL_PAGE_REQUEST',
    GETALL_PAGE_SUCCESS: 'EXCHANGE_GETALL_PAGE_SUCCESS',
    GETALL_PAGE_FAILURE: 'EXCHANGE_GETALL_PAGE_FAILURE',

    GETBYID_REQUEST: 'EXCHANGE_GETBYID_REQUEST',
    GETBYID_SUCCESS: 'EXCHANGE_GETBYID_SUCCESS',
    GETBYID_FAILURE: 'EXCHANGE_GETBYID_FAILURE',

    UPDATE_REQUEST: 'EXCHANGE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'EXCHANGE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'EXCHANGE_UPDATE_FAILURE',

    GET_ZERO_REQUEST: 'EXCHANGE_GET_ZERO_REQUEST',
    GET_ZERO_SUCCESS: 'EXCHANGE_GET_ZERO_SUCCESS',
    GET_ZERO_FAILURE: 'EXCHANGE_GET_ZERO_FAILURE',

    DELETE_ZERO_REQUEST: 'EXCHANGE_DELETE_ZERO_REQUEST',
    DELETE_ZERO_SUCCESS: 'EXCHANGE_DELETE_ZERO_SUCCESS',
    DELETE_ZERO_FAILURE: 'EXCHANGE_DELETE_ZERO_FAILURE',
}